var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPass(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.506,
    height: 16.409,
    viewBox: "0 0 23.506 16.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.041 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.462,12.944a.521.521,0,0,1,0,.521c-.729,1.288-4.284,6.944-10.666,6.944S3.858,14.755,3.129,13.465a.52.52,0,0,1,0-.521C3.858,11.656,7.413,6,13.8,6S23.733,11.654,24.462,12.944Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1bcc96",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,12.645a3.6,3.6,0,1,1-3.6-3.6,3.6,3.6,0,0,1,3.6,3.6Z",
    transform: "translate(1.193 0.611)",
    fill: "#1bcc96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPass);
export default __webpack_public_path__ + "static/media/showPass.4961db4dbaf73ef233d5bc4d32ee2384.svg";
export { ForwardRef as ReactComponent };